import { createStore } from 'vuex'
import firebase from 'firebase'

export default createStore({
  state: {
    items: [],
    genre: '',
    level: '',
    login_user: null,
  },
  mutations: {
    setLoginUser (state, user) {
      state.login_user = user
    },
    deleteLoginUser (state) {
      state.login_user = null
    },
    addItems(state, { id, item }) {
      item.id = id
      state.items.push(item)
    },
    updateAddress (state, { id, item }) {
      const index = state.items.findIndex(item => item.id === id)

      state.items[index] = item
    },
    deleteItem (state, { id }) {
      const index = state.items.findIndex(item => item.id === id)

      state.items.splice(index, 1)
    },
    setFilter(state, { level,genre }) {
      state.level = level
      state.genre = genre
      state.items.length = 0
    },
    filterList(state, { id, item }) {
      item.id = id
      state.items.push(item)
    },
  },
  actions: {
    setLoginUser ({ commit }, user) {
      commit('setLoginUser', user)
    },
    deleteLoginUser ({ commit }) {
      commit('deleteLoginUser')
    },
    logout () {
      firebase.auth().signOut()
    },
    addItems ({commit }, item) {
      firebase.firestore().collection(`admin`).add(item).then(doc => {
        commit('addItems', { id: doc.id, item })
      })
    },
    updateItem ({ commit }, { id, item }) {
      firebase.firestore().collection(`admin`).doc(id).update(item).then(() => {
        commit('updateItem', { id, item })
      })
    },
    deleteItem ({ commit }, { id }) {
      firebase.firestore().collection(`admin`).doc(id).delete().then(() => {
        commit('deleteItem', { id })
      })
    },
    fetchItems({ commit }) {
      firebase
        .firestore()
        .collection(`/admin`)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) =>
            commit('addItems', { id: doc.id, item: doc.data() })
          )
        })
    },
    setFilter({ commit }, {level,genre}) {
      commit('setFilter', { level,genre })
    },
    filterList({ commit }) {
      if (this.state.level == '' && this.state.genre == '') {
        firebase
          .firestore()
          .collection(`/admin`)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) =>
              commit('addItems', { id: doc.id, item: doc.data() })
            )
          })
      } else if (this.state.level == '' && this.state.genre != '') {
        firebase
          .firestore()
          .collection(`/admin`)
          .where('genre', '==', this.state.genre)
          .get().then((snapshot) => {
            snapshot.forEach((doc) =>
              commit('addItems', { id: doc.id, item: doc.data() })
            )
          })
      } else if (this.state.level != '' && this.state.genre == '') {
        firebase
          .firestore()
          .collection(`/admin`)
          .where('level', '==', this.state.level)
          .get().then((snapshot) => {
            snapshot.forEach((doc) =>
              commit('addItems', { id: doc.id, item: doc.data() })
            )
          })
      } else {
        firebase
          .firestore()
          .collection(`/admin`)
          .where('level', '==', this.state.level)
          .where('genre', '==', this.state.genre)
          .get().then((snapshot) => {
            snapshot.forEach((doc) =>
              commit('addItems', { id: doc.id, item: doc.data() })
            )
          })
      }
    },
  },
  modules: {},
  getters: {
    getItemById: (state) => (id) => state.items.find((item) => item.id === id),
  },
})
